import request from './request'
import qs from 'qs'
import store from '@/store'
//模块API
export { default } from './modules'

/******************************** 用户API ********************************/
export * from './user'
/******************************** 数据字典 ********************************/

//字典标签专用（通过code获取字典数组）
export const getDictItems = (code)=> request.get(`/dict/${code}`)
export const getDictConfig = (code)=> request.get(`/dict/config/${code}`)



/*************************************文件管理 ********************************/

//普通文件上传
export const uploadFile = (file)=> request.uploadFile("/upload",file);
//上传附件
export const uploadSourceFile = (file)=> request.uploadFile("/upload_source",file);
//获取附件
export const getSourceFiles = (stype,sid)=> request.get(`/file/source/${stype}/${sid}`);
//删除附件
export const deleteFiles = (ids)=> request.delete(`/file`,ids);
//绑定资源文件
export const ackFileList = (sourceType,sourceId,ids)=> request.put(`/file/source/${sourceType}/${sourceId}/ack`,ids)
//获取文件下载地址
export const getDownloadUrl = (fileId)=> request.get(`/file/download/${fileId}`)
//获取文件预览地址
export const getFileStreamUrl = (fileId,params)=> `${request.baseUrl}/file/stream/${fileId}?${qs.stringify({token:store.getters.token,...params})}`


/*************************************内容管理 ********************************/
//学员广告位
export const getAdList = (params)=> request.get("/open/api/ad",params);

//登录后广告位
export const getUserAd = (params)=>request.get("/user/api/ad",params);

//教练广告位
export const getCoachAdList = (params)=> request.get("/open/api/ad_coach",params);
//文章列表
export const getArticleList = (params)=>request.get(`/open/api/articles`,params);

//考场内部广告位
export const getExamAdList = (params)=> request.get("/cms/tenant/ad",params);


//文章详情
export const getArticleDetail = (id)=>request.get(`/open/api/article/detail`,{id});

//获取考场
export const getExamsList = ()=>request.get(`/open/api/exams`);



